import { VOVideo, VOConfig, VOGroup } from "./Structure.js";

export class Config {
    public static configTitle: string = "Default";
    public static defaultVideo: VOVideo = null;
    public static groups: VOGroup[] = [];
    public static showUngroupedVideos: boolean = true;

    public static init(config: VOConfig, video: VOVideo[]): void {
        if (!config) {
            console.warn("Could not initialize Config-class. Missing config parameter.");
            if (video)
                Config.defaultVideo = video[0];
            return;
        }
        Config.defaultVideo = config.default_video ? config.default_video : (config.groups ? config.groups[0].videos[0] : video[0]);
        Config.groups = config.groups || [];
        Config.showUngroupedVideos = config.show_ungrouped_videos;
    }
}